import React from 'react';
import { Icon } from 'semantic-ui-react';
import OutboundLink from '../../../../atoms/OutboundLink';
import { ChildrenPropType } from '../../../../services/proptypes';
import { generateGoogleExternalUrl } from '../../services/google-maps';
import { AddressPropType } from '../../types/address';
var defaultProps = {
  children: null,
  content: null,
  place: ''
};
export default function ExternalLinkMap(_ref) {
  var place = _ref.place,
    address = _ref.address,
    children = _ref.children,
    content = _ref.content;
  var url = generateGoogleExternalUrl(place, address);
  return /*#__PURE__*/React.createElement("div", {
    className: "external-link-map-container"
  }, /*#__PURE__*/React.createElement(OutboundLink, {
    to: url
  }, children || content || /*#__PURE__*/React.createElement("div", null, "Get directions ", /*#__PURE__*/React.createElement(Icon, {
    name: "map"
  }))));
}
ExternalLinkMap.defaultProps = defaultProps;